import gql from 'graphql-tag';

const ALL_RESOURCES_QUERY = gql`
  query Resources(
    $from: Int!
    $size: Int!
    $dops_full_text: String
    $dops_internal_account_ids: [String]
    $dops_resource_type: String
    $dops_regions: [String]
    $tags: [TagInput]
  ) {
    resources(
      from: $from
      size: $size
      dops_full_text: $dops_full_text
      dops_internal_account_ids: $dops_internal_account_ids
      dops_resource_type: $dops_resource_type
      dops_regions: $dops_regions
      tags: $tags
    ) {
      from
      size
      total_count
      results {
        id
        dops_resource_id
        dops_resource_uid
        dops_internal_account_id
        dops_cloud_account_id
        dops_resource_type
        dops_name
        dops_region
        dops_issue_summary {
          open_count
        }
        tags {
          key
          value
        }
      }
    }
  }
`;

export default ALL_RESOURCES_QUERY;
